import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "toolbarSidebar" }
const _hoisted_2 = { class: "splitToolbarButton toggled" }
const _hoisted_3 = {
  id: "viewThumbnail",
  class: "toolbarButton toggled vue-pdf-app-icon view-thumbnail",
  title: "Vista Miniaturas",
  tabindex: "2",
  "data-l10n-id": "thumbs"
}
const _hoisted_4 = {
  id: "viewOutline",
  class: "toolbarButton vue-pdf-app-icon view-outline",
  title: "Mostrar el esquema del documento (haga click para ver las marcaciones realizadas)",
  tabindex: "3",
  "data-l10n-id": "document_outline"
}
const _hoisted_5 = {
  id: "viewAttachments",
  class: "toolbarButton vue-pdf-app-icon view-attachments",
  title: "Ver Adjuntos",
  tabindex: "4",
  "data-l10n-id": "attachments"
}
const _hoisted_6 = {
  id: "thumbnailView",
  key: "vistaPrevia"
}
const _hoisted_7 = {
  id: "outlineView",
  class: "hidden"
}
const _hoisted_8 = {
  id: "attachmentsView",
  class: "hidden"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.isToolbarHidden]),
    id: "sidebarContainer"
  }, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "toolbar-sidebar-prepend"),
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createElementVNode("button", _hoisted_3, _cache[0] || (_cache[0] = [
          _createElementVNode("span", { "data-l10n-id": "thumbs_label" }, "Thumbnails", -1)
        ]), 512), [
          [_vShow, _ctx.showElem('sidebar.viewThumbnail', 'viewThumbnail')]
        ]),
        _withDirectives(_createElementVNode("button", _hoisted_4, _cache[1] || (_cache[1] = [
          _createElementVNode("span", { "data-l10n-id": "document_outline_label" }, "Document Outline", -1)
        ]), 512), [
          [_vShow, _ctx.showElem('sidebar.viewOutline', 'viewOutline')]
        ]),
        _withDirectives(_createElementVNode("button", _hoisted_5, _cache[2] || (_cache[2] = [
          _createElementVNode("span", { "data-l10n-id": "attachments_label" }, "Attachments", -1)
        ]), 512), [
          [_vShow, _ctx.showElem('sidebar.viewAttachments', 'viewAttachments')]
        ])
      ]),
      _renderSlot(_ctx.$slots, "toolbar-sidebar-append")
    ], 512), [
      [_vShow, !_ctx.isSidebarToolbarHidden]
    ]),
    _withDirectives(_createElementVNode("div", {
      class: _normalizeClass({ 'zero-top': _ctx.isSidebarToolbarHidden }),
      id: "sidebarContent"
    }, [
      _withDirectives(_createElementVNode("div", _hoisted_6, null, 512), [
        [_vShow, _ctx.showElem('sidebar.viewThumbnail')]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_7, null, 512), [
        [_vShow, _ctx.showElem('sidebar.viewOutline')]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_8, null, 512), [
        [_vShow, _ctx.showElem('sidebar.viewAttachments')]
      ])
    ], 2), [
      [_vShow, _ctx.showElem('sidebar')]
    ]),
    _cache[3] || (_cache[3] = _createElementVNode("div", {
      id: "sidebarResizer",
      class: "hidden"
    }, null, -1))
  ], 2)), [
    [_vShow, _ctx.showElem('sidebar')]
  ])
}